import React, { useEffect, useState } from "react"
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import Select from 'react-select'

import Search from 'pages/Parts/Search'
import Pagination from 'pages/Parts/Pagination'
import DatePicker from "react-datepicker";

import { PGET, GET, PUT, POST } from 'helpers/api'
import { formatDate, formatMoney, formatDateWithTime } from 'helpers/helpers'
import * as XLSX from 'xlsx'

function Index() {
	const URL = '/services/admin/api/pos-pageList'
	const authorities = JSON.parse(localStorage.getItem('authorities')) || [];
	const isAdmin = authorities.includes('ROLE_ADMIN');
	const { t } = useTranslation()

	// Payment configs
	const paymentTypes = [
		{ 'id': 1, 'name': t('CASH') },
		{ 'id': 2, 'name': t('TRANSFER') },
		{ 'id': 3, 'name': t('MONEY_TRANSFER') },
	]
	const tariffs = [
		{ "id": 1, "name": "START", "value": 150000 },
		{ "id": 2, "name": "STANDART", "value": 300000 },
		{ "id": 3, "name": "PREMIUM", "value": 700000 }
	]

	const settings = useSelector(state => state.settings)
	const [pageCount, setPageCount] = useState(0)
	const [totalCount, setTotalCount] = useState(0)
	const [modalPayment, setModalPayment] = useState(false)
	const [modalPaymentHistory, setModalPaymentHistory] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [data, setData] = useState([])
	const [payments, setPayments] = useState([])
	const [ActivenFrom, setActivenFrom] = useState(null);
	const [pageSize, setPageSize] = useState(20)

	function selectItem(item) {
		const itemCopy = {
			...item,
			posId: item.id,
			amountIn: "",
			paymentMethod: 3,
			note: ""
		}
		setSelectedItem(itemCopy)
	}

	async function payment(e) {
		e.preventDefault();
		const { posId, amountIn, paymentMethod, note } = selectedItem
		const sendData = { posId, amountIn, paymentMethod, note }
		const response = await POST('/services/admin/api/pos-payment', sendData, { loader: true })
		if (response) {
			showPaymentModal(false)
			getData()
		}
	}

	function showPaymentModal(bool) {
		if (!bool) {
			const selectedItemCopy = { ...selectedItem }
			selectedItemCopy.posId = null
			selectedItemCopy.amountIn = ""
			selectedItemCopy.paymentMethod = 2
			selectedItemCopy.note = ''
		}

		if (!selectedItem?.id) {
			toast.warning(t('NO_POS_SELECTED'))
			return
		}
		setModalPayment(bool)
	}

	async function showPaymentHistoryModal(bool, posId) {
		if (!bool) {
			setModalPaymentHistory(bool)
			return;
		}
		const response = await GET('/services/admin/api/pos-payment-history/' + posId, {}, { loader: true })
		setPayments(response)
		setModalPaymentHistory(bool)
	}

	async function handleDocumentsInCreate(e, index) {
		if (!isAdmin) return;
		const dataCopy = [...data]
		dataCopy[index][e.target.name] = e.target.checked
		setData(dataCopy)
		const sendData = {
			id: dataCopy[index]['id'],
			activated: e.target.checked,
		}
		await PUT('/services/admin/api/pos-activate', sendData, { loader: true })
	}

	async function getData() {
		const response = await PGET('/services/admin/api/pos-pageList', { size: pageSize }, { loader: true })
		if (response) {
			setTotalCount(Math.ceil(response.headers['x-total-count']))
			setPageCount(Math.ceil(response.headers['x-total-count'] / pageSize))
			setData(response.data)
		}
	}

	async function paginate(data) {
		const response = await PGET('/services/admin/api/pos-pageList', { page: data.selected, size: pageSize }, { loader: true })
		setData(response.data);
	}

	async function search(data, searchValue) {
		setData(data);
		if (searchValue.length > 0) {
			setPageCount(0)
		}
	}

	useEffect(() => {
		getData()
	}, [pageSize]) // eslint-disable-line react-hooks/exhaustive-deps

	function showVatInput(index) {
		const dataCopy = [...data]
		for (let i = 0; i < dataCopy.length; i++) {
			dataCopy[index].showInput = true
			if (!dataCopy[i].showInput) {
				dataCopy[i].showInput = false
			}
		}
		setData(dataCopy)
	}

	const setChanges = async (index) => {
		const dataCopy = [...data];
		const posInfo = dataCopy[index];
		dataCopy[index].showInput = false
		try {
			await POST('/services/admin/api/fix-balance', { activeUntil: posInfo.paidUntil, balance: posInfo.balance, posId: posInfo.id }, { loader: true });
		} catch (error) {
			console.error(error);
		}
	};

	function removeInput(index) {
		const dataCopy = [...data]
		dataCopy[index].showInput = false
		setData(dataCopy)
	}

	function handlePageSizeChange(selectedOption) {
		setPageSize(selectedOption.value)
	}

	const pageSizeOptions = [
		{ value: 20, label: '20' },
		{ value: 50, label: '50' },
		{ value: 100, label: '100' },
		{ value: 500, label: '500' },
		{ value: 1000, label: '1000' }
	]

	// Excel export function
	function exportToExcel() {
		const excelData = data.map((item, index) => {
			const excelRow = {
				'№': item.rowNum || index + 1,
				[t('ID')]: item.id,
				[t('OWNER')]: item.ownerLogin,
				[t('SALE_POINT_NAME')]: item.name,
				[t('DATE_OF_CREATION')]: formatDate(item.createdDate),
				[t('PAID_UNTIL')]: item.paidUntil instanceof Date
					? `${item.paidUntil.getDate().toString().padStart(2, '0')}.${(item.paidUntil.getMonth() + 1).toString().padStart(2, '0')}.${item.paidUntil.getFullYear()}`
					: item.paidUntil || '',
				[t('BALANCE')]: formatMoney(item.balance),
				// NEW: add today's metrics
				[t('TODAY_CHEQUES')]: item.todayChequeCount ?? 0,
				[t('TODAY_PRODUCTS_QTY')]: item.todayTotalQuantity ?? 0,
				[t('TARIFF')]: tariffs.find(element => element.id === item.tariffId)?.name || '',
				[t('TARIFF_AMOUNT')]: formatMoney(item.tariff),
				[t('ACTIVATED')]: item.activated ? t('ACTIVE') : t('INACTIVE')
			}

			// Admin-only columns removed from export to keep it clean
			return excelRow
		})

		const ws = XLSX.utils.json_to_sheet(excelData)
		const wb = XLSX.utils.book_new()
		XLSX.utils.book_append_sheet(wb, ws, t('POSES'))
		XLSX.writeFile(wb, `${t('POSES')}_${new Date().toLocaleDateString()}.xlsx`)
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{t('POSES')} ({totalCount})
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary me-2" onClick={exportToExcel}>
						<i className="uil uil-file-export me-2"></i>
						Excel
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex mb-3">
						<div className="me-2">
							<Search url={URL} search={search} getData={getData}></Search>
						</div>
						<div className="me-2" style={{ minWidth: '120px' }}>
							<Select
								options={pageSizeOptions}
								value={pageSizeOptions.find(option => option.value === pageSize)}
								onChange={handlePageSizeChange}
								placeholder="Page Size"
								isSearchable={false}
							/>
						</div>
						<div>
							<button className="btn btn-outline-primary btn-wide me-2" onClick={showPaymentModal}>
								{t('PAY')}
							</button>
						</div>
					</div>

					<div className="table-responsive">
						<table className="table mb-0">
							<thead>
								<tr>
									<th>№</th>
									<th>{t('ID')}</th>
									<th>{t('OWNER')}</th>
									<th>{t('SALE_POINT_NAME')}</th>
									<th className="text-center">{t('DATE_OF_CREATION')}</th>
									<th className="text-center">{t('PAID_UNTIL')}</th>
									<th className="text-center">{t('BALANCE')}</th>
									{/* EDIT column commented per request */}
									{/* {isAdmin && (<th className="text-center">{t('EDIT')}</th>)} */}
									<th className="text-center">{t('TARIFF')}</th>
									<th className="text-center">{t('TARIFF_AMOUNT')}</th>
									{/* NEW: today’s metrics */}
									<th className="text-center">{t('TODAY_CHEQUES')}</th>
									<th className="text-center">{t('TODAY_PRODUCTS_QTY')}</th>
									<th className="text-center">{t('ACTIVATED')}</th>
									{isAdmin && (<th className="text-center">{t('ACTION')}</th>)}
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr className={'tr-middle ' + ((selectedItem && selectedItem.id === item.id) ? 'table-tr-active' : '')}
										key={index} onClick={() => selectItem(item)}>
										<td>{item.rowNum}</td>
										<td>{item.id}</td>
										<td>{item.ownerLogin}</td>
										<td>{item.name}</td>

										<td className="text-center">{formatDate(item.createdDate)}</td>

										<td>
											<div className="d-flex align-items-center justify-content-center">
												{!item.showInput &&
													(item.paidUntil instanceof Date
														? `${item.paidUntil.getDate().toString().padStart(2, '0')}.${(item.paidUntil.getMonth() + 1).toString().padStart(2, '0')}.${item.paidUntil.getFullYear()}`
														: item.paidUntil
													)
												}
												{item.showInput && (
													<div className="form-group col-6">
														<DatePicker
															className="form-control"
															dateFormat="dd.MM.yyyy"
															required
															selected={
																item.paidUntil instanceof Date
																	? item.paidUntil
																	: (() => {
																		const parts = item.paidUntil?.split('.');
																		return parts?.length === 3
																			? new Date(parts[2], parts[1] - 1, parts[0])
																			: null;
																	})()
															}
															onChange={(date) => {
																const updatedData = [...data];
																updatedData[index].paidUntil = date;
																setData(updatedData);
															}}
														/>
													</div>
												)}
											</div>
										</td>

										<td className="text-center">
											{!item.showInput && formatMoney(item.balance)}
											{item.showInput &&
												<div className="d-flex align-items-center justify-content-center">
													<div className="form-group col-6">
														<input
															type="number"
															className="form-control"
															value={item.balance}
															placeholder={t('BALANCE')}
															onChange={(e) => {
																const newBalance = e.target.value;
																const updatedData = [...data];
																updatedData[index].balance = newBalance;
																setData(updatedData);
															}}
														/>
													</div>
												</div>
											}
										</td>

										{/* EDIT column commented per request */}
										{/* {isAdmin && (<td>
											{!item.showInput ?
												<div className="d-flex align-items-center justify-content-center">
													<div className="table-action-button table-action-primary-button" onClick={() => showVatInput(index)}>
														<i className="uil-edit-alt"></i>
													</div>
												</div> : <div className="d-flex">
													<div className="table-action-button table-action-primary-button me-2" onClick={() => setChanges(index)}>
														<i className="uil-check"></i>
													</div>
													<div className="table-action-button table-action-danger-button" onClick={() => removeInput(index)}>
														<i className="uil-times"></i>
													</div>
												</div>
											}
										</td>)} */}

										<td className="text-center">{tariffs.find(element => element.id === item.tariffId)?.name}</td>
										<td className="text-center">{formatMoney(item.tariff)}</td>

										{/* NEW: today’s metrics cells */}
										<td className="text-center">
											<div className="text-nowrap">{item.todayChequeCount ?? 0}</div>
										</td>
										<td className="text-center">
											<div className="text-nowrap">{item.todayTotalQuantity ?? 0}</div>
										</td>

										<td className="text-center">
											<div className="d-flex justify-content-center">
												<div className="form-check form-switch form-switch-lg">
													<input
														type="checkbox"
														disabled={!isAdmin}
														className="form-check-input"
														name="activated"
														checked={item.activated}
														onChange={(e) => handleDocumentsInCreate(e, index)}
													/>
												</div>
											</div>
										</td>

										{isAdmin && (<td>
											<div className="d-flex justify-content-center">
												<div className="d-flex justify-content-center me-2">
													<Link className="table-action-button table-action-primary-button"
														to={'/pos-update/' + item.id}>
														<i className="uil-edit-alt"></i>
													</Link>
												</div>
											</div>
										</td>)}
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<Pagination pageCount={pageCount} paginate={paginate}></Pagination>
				</div>
			</div>

			{/* PAYMENT */}
			<Modal show={modalPayment} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={() => showPaymentModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('PAY')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<span>{t('OWNER')}</span>
						<span>{selectedItem.ownerLogin}</span>
					</div>
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<span>{t('POS')}</span>
						<span>{selectedItem.name}</span>
					</div>
					<form onSubmit={payment} autoComplete="off">
						<div className="form-group">
							<label>{t('PAYMENT_METHOD')}</label>
							<Select
								options={paymentTypes}
								value={paymentTypes.find(option => option.id === selectedItem.paymentMethod)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'paymentMethod': option.id })}
								placeholder=""
								noOptionsMessage={() => t('LIST_IS_EMPTY')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('AMOUNT')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" name="amountIn" autoFocus required
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amountIn': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('NOTE')}</label>
							<input type="text" className="form-control" name="note"
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => showPaymentModal(false)} tabIndex="-1">{t('CANCEL')}</button>
							<button type="submit" className="btn btn-success w-100" disabled={!selectedItem.amountIn}>
								{t('SAVE')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* PAYMENT */}

			{/* PAYMENT HISTORY */}
			<Modal show={modalPaymentHistory} animation={false} centered size="lg"
				dialogClassName="update-modal-width" backdrop="static" onHide={() => showPaymentHistoryModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('HISTORY')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table mb-0">
							<thead>
								<tr>
									<th>{t('TYPE')}</th>
									<th>{t('NOTE')}</th>
									<th>Создал</th>
									<th>Оплата</th>
									<th className="text-center">{t('DATE')}</th>
								</tr>
							</thead>
							<tbody>
								{payments.map((item, index) => (
									<tr key={index}>
										<td>{item.paymentTypeName}</td>
										<td>{item.note}</td>
										<td>{item.createdBy}</td>
										<td>
											<div className="text-nowrap">
												{formatMoney(item.amountIn)}
											</div>
										</td>
										<td>
											<div className="text-nowrap">
												{formatDateWithTime(item.createdDate)}
											</div>
										</td>
									</tr>
								))
								}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* PAYMENT HISTORY */}
		</>
	)
}

export default Index
